import { render, staticRenderFns } from "./SideTrigger.vue?vue&type=template&id=57d370b2&scoped=true"
import script from "./SideTrigger.vue?vue&type=script&lang=js"
export * from "./SideTrigger.vue?vue&type=script&lang=js"
import style0 from "./SideTrigger.vue?vue&type=style&index=0&id=57d370b2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d370b2",
  null
  
)

export default component.exports